import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EMPTY} from 'rxjs';
import {catchError, filter, switchMap, tap} from 'rxjs/operators';

import {EVENT_BUS} from '../../../../../shared/domain/tokens/event-bus.token';
import {PaymentAttemptedEvent} from '../../../../../shared/application/events/payment/payment-attempted.event';
import {LockBookingUseCase} from '../use-cases/lock-booking.use-case';
import {BookingLockCheckedEvent} from '../../../../../shared/application/events/booking/booking-lock-checked.event';

@Injectable()
export class ValidateLockSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly lockBooking = inject(LockBookingUseCase);

  constructor() {
    this.eventBus.ofType(PaymentAttemptedEvent).pipe(
      filter(({payload}) => !!payload?.bookingId && !!payload?.correlationId),
      switchMap(({payload}) =>
        this.lockBooking.execute(payload.bookingId).pipe(
          tap(({locked, deviceName}) =>
            this.eventBus.publish(
              new BookingLockCheckedEvent({
                isLocked: locked,
                correlationId: payload.correlationId,
                deviceName: locked ? '' : deviceName,
              })
            )
          ),
          catchError(() => EMPTY)
        )
      ),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
